import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { cardType, Translationtype } from "utils";
import TransferListItem from "./TransferListItem";

interface TransferListSortableItemProps {
  item: cardType;
  t: Translationtype;
  deleteCard: (id: string) => void;
  listItemClick: (eventType: number) => void;
}

export function TransferListSortableItem({
  item,
  t,
  deleteCard,
  listItemClick,
  ...props
}: TransferListSortableItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <TransferListItem
      ref={setNodeRef}
      style={style}
      {...attributes}
      dragHandleListeners={listeners}
      item={item}
      t={t}
      deleteCard={deleteCard}
      listItemClick={listItemClick}
      {...props}
    />
  );
}

export default TransferListSortableItem;
